import { render, staticRenderFns } from "./ArticleManagement.vue?vue&type=template&id=359f66c8"
import script from "./ArticleManagement.vue?vue&type=script&lang=js"
export * from "./ArticleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports